import Choices from 'choices.js';
class ComponentFilterSelectNews {
  constructor() {
    this._init();
  }

  _init() {
    const filterEntrepriseSelect = document.getElementById("filter-select-news__select--entreprise") as HTMLSelectElement;
    const filterCategorieSelect = document.getElementById("filter-select-news__select--categorie") as HTMLSelectElement;

    if (filterEntrepriseSelect) {
      new Choices(filterEntrepriseSelect, {
        searchEnabled: false,
        searchChoices: false,
        itemSelectText: '',
      });
      filterEntrepriseSelect.addEventListener("change", () => {
        const selectedValue = filterEntrepriseSelect.value;

        const url = new URL(window.location.href);
        url.searchParams.set("entreprise", selectedValue);
        window.location.href = url.toString();
      });
    }
    if (filterCategorieSelect) {
      new Choices(filterCategorieSelect, {
        searchEnabled: false,
        searchChoices: false,
        itemSelectText: '',
      });
      filterCategorieSelect.addEventListener("change", () => {
        const selectedValue = filterCategorieSelect.value;

        const url = new URL(window.location.href);
        url.searchParams.set("categorie", selectedValue);
        window.location.href = url.toString();
      });
    }
  }
}

export const componentFilterSelectNews = new ComponentFilterSelectNews();
